module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/apprenticeHandsHips3-406e8811bf51c1fbab97ac9ffe403280.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/apprenticeHandsHips3.png
// module id = 2480
// module chunks = 2